module.exports = __webpack_public_path__ + "static/media/19_OTT_Invitationexample-03.25f2f82e.jpg";